<script lang="ts">
  import type { SummedResult } from './types'
  export let result: SummedResult
  export let row: number
  export let column: number
  export let i: string
</script>

<div
  style="
  grid-row: {row} / span 1;
  grid-column: {column} / span 1;
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  height: 4em;
  margin-left: {i};
  margin-right: {i};
"
  class="result"
>
  <div
    style="
    flex: {result.green};
    background-color: green;
  "
  />
  <div
    style="
    flex: {result.amber};
    background-color: orange;
  "
  />
  <div
    style="
    flex: {result.red};
    background-color: red;
  "
  />
</div>
